var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClockHistory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "clock-history",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    d: "M19.159,1.845Q18.58,1.81,18,1.81V0c.44,0,.882.013,1.323.039l-.164,1.8Zm4.509.814a18.708,18.708,0,0,0-2.216-.541L21.945.351a20.906,20.906,0,0,1,2.533.62l-.81,1.689Zm3.083,1.285q-.483-.259-.988-.489L26.872,1.88a18.873,18.873,0,0,1,2.2,1.184L27.691,4.492q-.458-.287-.941-.546Zm4.127,3.24a13.7,13.7,0,0,0-1.469-1.441l1.629-1.249a16.316,16.316,0,0,1,1.681,1.647l-1.84,1.043Zm1.674,2.448q-.221-.431-.481-.847L34.08,7.97a13.036,13.036,0,0,1,1.012,1.97l-2.137.566q-.181-.443-.4-.875Zm1.193,4.539a10.269,10.269,0,0,0-.225-1.855l2.216-.308A11.86,11.86,0,0,1,36,14.125l-2.25.045Zm-.295,2.785c.074-.308.135-.614.182-.923l2.234.223a11.961,11.961,0,0,1-.518,2.091l-2.169-.484q.155-.448.27-.907Zm-2.142,4.307A12.216,12.216,0,0,0,32.4,19.618l2.057.733a13.968,13.968,0,0,1-1.249,1.88l-1.9-.969Zm-2.169,2.181c.274-.22.538-.449.787-.685l1.706,1.182q-.433.4-.9.782l-1.591-1.28Z",
    transform: "translate(-5.997)",
    fill: "#329bc9",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    d: "M14.482,1.875A12.755,12.755,0,0,0,2.242,11.6a13.321,13.321,0,0,0,5.9,14.762,12.349,12.349,0,0,0,15.3-2.086l1.28,1.326A14.115,14.115,0,0,1,7.238,27.991,15.225,15.225,0,0,1,.488,11.117,14.579,14.579,0,0,1,14.482,0Z",
    transform: "translate(0.007)",
    fill: "#329bc9",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M16.875,6.75A1.125,1.125,0,0,1,18,7.875V19.6l7.308,4.176a1.125,1.125,0,0,1-1.116,1.953l-7.875-4.5a1.125,1.125,0,0,1-.567-.977V7.875A1.125,1.125,0,0,1,16.875,6.75Z",
    transform: "translate(-3.645 -2.399)",
    fill: "#329bc9",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockHistory);
export default __webpack_public_path__ + "static/media/clock-history.09796029f9c26c0604ae6f8c3c791a1b.svg";
export { ForwardRef as ReactComponent };